import { Staff as StaffPB } from "gen/company/models_pb"
import { BoolFilter } from "gen/search/service/service_pb"
import { useMemo } from "react"
import { UUID } from "shared-ts/classes/uuid"
import {
  usePopoverSelect,
  UsePopoverSelectProps,
  UsePopoverSelectRes,
} from "shared-web/components/composite/popover"

import { useSearchStaffs } from "features/api/search"
import { Staff } from "lib/staff"

type UseStaffsPopoverSelectProps = Pick<
  UsePopoverSelectProps<StaffPB>,
  | "selected"
  | "onSelect"
  | "defaultSelected"
  | "selectedKeyOverride"
  | "selectedLabelOverride"
>

export type UseStaffsPopoverSelectRes = UsePopoverSelectRes<StaffPB>

function useStaffsPopoverSelect(
  props: UseStaffsPopoverSelectProps
): UseStaffsPopoverSelectRes {
  const { results, setQuery } = useSearchStaffs(
    { isActiveFilter: BoolFilter.TRUE },
    { ignoreSearchQuery: true }
  )

  const staffs = useMemo(() => {
    const out: StaffPB[] = []
    for (const r of results) {
      if (r.staff) out.push(r.staff)
    }
    return out
  }, [results])

  return usePopoverSelect({
    items: staffs,
    keyExtractor,
    labelExtractor,
    onChangeQuery: setQuery,
    ...props,
  })
}

function keyExtractor(staff: StaffPB): string {
  return UUID.idString(staff.id)
}

function labelExtractor(staff: StaffPB): string {
  return Staff.fromPB(staff).fullName
}

export default useStaffsPopoverSelect
